/**
 * PDP accessory slider: staged add with main ATC, optional add-on-click.
 * Depends: pubsub.js, constants.js, base.js (fetchConfig), theme routes, cart-drawer.
 */
(function () {
  function wtFormatCents(cents) {
    const n = Number(cents);
    if (Number.isNaN(n)) return "";
    const fmt = window.__wtMoneyFormat || "${{amount}}";
    const amount = (n / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/gi, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, String(Math.round(n / 100)));
  }

  function getSectionIdFromProductForm(form) {
    // Never use form.id — Shopify product forms include <input name="id">, which
    // shadows the form element's id property with that input node.
    const fid =
      form && typeof form.getAttribute === "function"
        ? form.getAttribute("id")
        : "";
    const m = typeof fid === "string" ? fid.match(/^product-form-(.+)$/) : null;
    return m ? m[1] : null;
  }

  function getMainQty(sectionId) {
    const form = document.getElementById(`product-form-${sectionId}`);
    const raw = form?.querySelector('[name="quantity"]')?.value;
    const q = parseInt(raw, 10);
    return Number.isFinite(q) && q > 0 ? q : 1;
  }

  function collectStagedLines(sectionId) {
    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (!section) return [];
    const lines = [];
    section
      .querySelectorAll(
        'pdp-accessory-slider[data-behavior="stage_with_main_atc"] .js-pdp-accessory-card[data-staged="true"]',
      )
      .forEach((card) => {
        const btn = card.querySelector(".js-pdp-accessory-add");
        if (!btn || btn.disabled) return;
        const id = Number(btn.dataset.variantId);
        if (!Number.isFinite(id)) return;
        lines.push({
          id,
          priceCents: Number(btn.dataset.priceCents) || 0,
        });
      });
    return lines;
  }

  function showCombinedForSection(sectionId) {
    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (!section) return true;
    const stagedCard = section.querySelector(
      'pdp-accessory-slider[data-behavior="stage_with_main_atc"] .js-pdp-accessory-card[data-staged="true"]',
    );
    if (!stagedCard) return true;
    const slider = stagedCard.closest("pdp-accessory-slider");
    return slider?.dataset.showCombinedTotal !== "false";
  }

  function atcSuffixForSection(sectionId) {
    const section = document.getElementById(`shopify-section-${sectionId}`);
    const staged = collectStagedLines(sectionId);
    if (!staged.length || !section) return "";
    const withStaged = section.querySelector(
      'pdp-accessory-slider[data-behavior="stage_with_main_atc"] .js-pdp-accessory-card[data-staged="true"]',
    );
    const slider = withStaged?.closest("pdp-accessory-slider");
    const template =
      slider?.dataset?.atcSuffix || "({count} ITEMS)";
    // {count} = lines added on submit: main product (1) + each staged accessory row
    const totalLines = 1 + staged.length;
    return template.replace(/\{count\}/g, String(totalLines));
  }

  function updateMainAtcButtonForSection(sectionId) {
    const btn = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (!btn) return;
    const priceEl = btn.querySelector(".js-atc-label-price");
    const suffixEl = btn.querySelector(".js-atc-label-suffix");
    if (!priceEl || !suffixEl) return;

    const state = window.__pdpAtcBySection?.[sectionId];
    const staged = collectStagedLines(sectionId);
    const qty = getMainQty(sectionId);
    const showCombined = showCombinedForSection(sectionId);

    if (!state || state.available === false) {
      priceEl.textContent = "";
      suffixEl.textContent = "";
      suffixEl.classList.add("hidden");
      return;
    }

    const mainCents = state.priceCents || 0;
    const mainTotal = mainCents * qty;
    const stagedTotal = staged.reduce((s, l) => s + l.priceCents, 0);
    const displayCents =
      showCombined && staged.length ? mainTotal + stagedTotal : mainTotal;

    priceEl.textContent = displayCents ? wtFormatCents(displayCents) : "";

    if (staged.length) {
      suffixEl.textContent = atcSuffixForSection(sectionId);
      suffixEl.classList.remove("hidden");
    } else {
      suffixEl.textContent = "";
      suffixEl.classList.add("hidden");
    }
  }

  function seedMainVariantFromDom() {
    window.__pdpAtcBySection = window.__pdpAtcBySection || {};
    document.querySelectorAll("product-form[data-section-id]").forEach((pf) => {
      const sid = pf.dataset.sectionId;
      if (!sid || window.__pdpAtcBySection[sid]) return;
      const form = pf.querySelector('form[data-type="add-to-cart-form"]');
      const addBtn = pf.querySelector('[name="add"]');
      const price = parseInt(pf.dataset.initialVariantPrice, 10);
      const vid = form?.querySelector('[name="id"]')?.value;
      window.__pdpAtcBySection[sid] = {
        variantId: vid ? Number(vid) : null,
        priceCents: Number.isFinite(price) ? price : 0,
        available: addBtn ? !addBtn.hasAttribute("disabled") : true,
      };
    });
  }

  function dispatchStagingChanged(sectionId) {
    updateMainAtcButtonForSection(sectionId);
    document.dispatchEvent(
      new CustomEvent("pdp:accessory-staging-changed", { detail: { sectionId } }),
    );
  }

  function parseVariantsJson(card) {
    const el = card.querySelector(".js-pdp-acc-variants-json");
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch {
      return [];
    }
  }

  function findVariant(variants, id) {
    return variants.find((v) => Number(v.id) === Number(id));
  }

  /*
    Toggle the accessory ADD pill between the "available" and "sold-out"
    visual states. Single source of truth for:
      - swatch clicks (.js-pdp-accessory-swatch)
      - dropdown changes (.js-pdp-acc-variant-select)
      - any other future variant-driving control

    State changes:
      - btn.disabled / .is-disabled        → blocks toggleStaged and
                                              addAccessoryImmediate, both of
                                              which early-out on btn.disabled
      - .js-pdp-acc-label-text             → swaps between data-label-default
                                              ("Add", "ADD", etc.) and
                                              data-label-sold-out ("Sold out")
      - .js-pdp-acc-price-suffix           → empty string when sold out so the
                                              pill reads as "Sold out" alone;
                                              " - $XX.XX" when available

    The icon-style button has no label span, so the label/suffix updates
    silently no-op there — the CSS treatment for .is-disabled is what
    carries the sold-out signal on icon-only buttons.
  */
  function setAccessoryBtnAvailability(btn, available, priceCents) {
    if (!btn) return;
    const labelText = btn.querySelector(".js-pdp-acc-label-text");
    const suffix = btn.querySelector(".js-pdp-acc-price-suffix");
    if (available) {
      btn.disabled = false;
      btn.classList.remove("is-disabled");
      if (labelText) {
        labelText.textContent = btn.dataset.labelDefault || "Add";
      }
      if (suffix) {
        suffix.textContent = priceCents ? ` - ${wtFormatCents(priceCents)}` : "";
      }
    } else {
      btn.disabled = true;
      btn.classList.add("is-disabled");
      if (labelText) {
        labelText.textContent = btn.dataset.labelSoldOut || "Sold out";
      }
      if (suffix) {
        suffix.textContent = "";
      }
    }
  }

  function applyVariantToCard(card, variant, variants) {
    const v = variant || findVariant(variants, card.dataset.currentVariantId);
    if (!v) return;

    const img = card.querySelector(".js-pdp-acc-img");
    const picture = card.querySelector(".js-pdp-acc-picture");
    if (img && v.img_300) {
      img.src = v.img_300;
      const parts = [v.img_300 && `300w`];
      const srcset = [
        v.img_300 ? `${v.img_300} 300w` : "",
        v.img_600 ? `${v.img_600} 600w` : "",
        v.img_900 ? `${v.img_900} 900w` : "",
      ]
        .filter(Boolean)
        .join(", ");
      if (srcset) img.srcset = srcset;
      img.alt = v.alt || "";
    } else if (picture && v.img_300 && !img) {
      picture.innerHTML = `<img class="wt-dot__image js-pdp-acc-img" src="${v.img_300}" alt="${(v.alt || "").replace(/"/g, "&quot;")}" width="${v.featured_width || 300}" height="${v.featured_height || 300}" loading="lazy">`;
    }

    const btn = card.querySelector(".js-pdp-accessory-add");
    if (btn) {
      btn.dataset.variantId = String(v.id);
      btn.dataset.priceCents = String(v.price);
      btn.dataset.available = v.available ? "true" : "false";
      setAccessoryBtnAvailability(btn, v.available, v.price);

      /*
        Auto-unstage on sold-out swap: if this card was staged (PDP
        "stage_with_main_atc" flow) and the shopper picks a sold-out
        variant via swatch or dropdown, the staged state has to clear.
        Otherwise the main ATC accumulator (updateMainAtcButtonForSection)
        would still include this card's variant_id in its total and the
        cart/add request on the next main-ATC click would fail with the
        sold-out variant. We bypass toggleStaged here because it
        early-outs on btn.disabled (which we just flipped to true), so
        we reset the staging DOM inline and dispatch the section
        re-calc event.
      */
      if (!v.available && card.dataset.staged === "true") {
        card.dataset.staged = "false";
        btn.classList.remove("is-staged");
        btn.setAttribute("aria-pressed", "false");
        const bag = btn.querySelector(".js-pdp-acc-btn-icon-bag");
        const check = btn.querySelector(".js-pdp-acc-btn-icon-check");
        const textStyle = isTextStyleAccessoryButton(btn);
        if (bag) bag.classList.toggle("hidden", textStyle);
        if (check) check.classList.add("hidden");
        const label = btn.querySelector(".js-pdp-acc-btn-label");
        if (label) label.classList.remove("hidden");
        const sectionEl = card.closest("[id^='shopify-section-']");
        const sectionId = sectionEl?.id?.replace("shopify-section-", "");
        if (sectionId) dispatchStagingChanged(sectionId);
      }
    }

    const inline = card.querySelector(".js-pdp-acc-inline-price");
    if (inline && v.price) {
      inline.textContent = wtFormatCents(v.price);
    }

    // Variant label under the title: shows option values like "Black / Small"
    // (or "Twin" for a pinned car-seat adapter). Server already emits the
    // initial label; here we keep it in sync as the shopper clicks swatches.
    // The label is intentionally blank for single-variant products whose
    // option1 is Shopify's "Default Title" fallback; in that case we hide
    // the row via the modifier class so we don't leave an empty line.
    const variantLabel = card.querySelector(".js-pdp-acc-variant");
    if (variantLabel) {
      const label = typeof v.label === "string" ? v.label : "";
      variantLabel.textContent = label;
      variantLabel.classList.toggle("wt-dot__variant--hidden", label === "");
    }

    // Keep the "More info" link pointed at the selected variant so the PDP
    // opens with the same variant the shopper picked in the card.
    const moreInfoLink = card.querySelector(".wt-dot__more-info-link");
    if (moreInfoLink) {
      const base = (moreInfoLink.getAttribute("href") || "").split("?")[0];
      if (base) moreInfoLink.setAttribute("href", `${base}?variant=${v.id}`);
    }

    card.dataset.currentVariantId = String(v.id);
  }

  function isTextStyleAccessoryButton(btn) {
    return btn?.classList?.contains("shoppable-video__add-button--text");
  }

  function toggleStaged(card, root) {
    const btn = card.querySelector(".js-pdp-accessory-add");
    if (!btn || btn.disabled) return;
    const sectionEl = card.closest("[id^='shopify-section-']");
    const sectionId = sectionEl?.id?.replace("shopify-section-", "");
    const next = card.dataset.staged !== "true";
    card.dataset.staged = next ? "true" : "false";
    btn.classList.toggle("is-staged", next);
    btn.setAttribute("aria-pressed", next ? "true" : "false");

    const bag = btn.querySelector(".js-pdp-acc-btn-icon-bag");
    const check = btn.querySelector(".js-pdp-acc-btn-icon-check");
    const textStyle = isTextStyleAccessoryButton(btn);
    // Text-style buttons: never show bag; only show check while staged
    if (bag) bag.classList.toggle("hidden", next || textStyle);
    if (check) check.classList.toggle("hidden", !next);

    // When staged, the visible label (text + price suffix) is hidden so the
    // button collapses to a checkmark only. Showing "Added" is misleading —
    // items aren't truly in the cart until the merchant taps the main ATC.
    // Hiding the whole label avoids that confusion; aria-label keeps the
    // button's accessible name intact while the visible text is gone.
    const label = btn.querySelector(".js-pdp-acc-btn-label");
    if (label) label.classList.toggle("hidden", next);
    const productTitle =
      card.querySelector(".wt-dot__title")?.textContent?.trim() || "";
    const defaultLabel = btn.dataset.labelDefault || "Add";
    btn.setAttribute(
      "aria-label",
      next
        ? `${productTitle} selected, tap to remove`.trim()
        : `${defaultLabel} ${productTitle}`.trim(),
    );

    if (sectionId) dispatchStagingChanged(sectionId);
  }

  async function addAccessoryImmediate(card, root) {
    const btn = card.querySelector(".js-pdp-accessory-add");
    if (!btn || btn.disabled) return;
    const id = Number(btn.dataset.variantId);
    if (!Number.isFinite(id)) return;

    const cart = document.querySelector("cart-drawer");
    const body = {
      items: [{ id, quantity: 1 }],
      sections: cart?.getSectionsToRender?.().map((s) => s.id).join(",") || "",
      sections_url: window.location.pathname,
    };

    /*
      Show a loading spinner on the pill while the cart/add request is
      in flight. The button has a `.shoppable-video__add-button__loader`
      overlay (added in pdp-accessory-card.liquid) that the existing
      `.wt-cart__cross-sell .shoppable-video__add-button.is-loading`
      CSS reveals. Without this, the user clicks ADD and sees nothing
      change until the cart drawer re-renders ~200–500ms later — the
      reported "no loading state" symptom. `aria-busy` mirrors the
      visual state for AT users; `aria-disabled` keeps the button
      out of the focus/activate flow for the brief request window
      (we don't set `disabled` because then we couldn't read the
      pressed-state focus ring back if we wanted to).

      On success, cart.renderContents replaces the entire drawer DOM,
      so this exact button node is detached before `finally` runs and
      the cleanup is effectively a no-op on the visible UI — but it
      still matters for the error path (network failure, 4xx, etc.)
      where the original DOM is preserved and the spinner must clear.
    */
    btn.classList.add("is-loading");
    btn.setAttribute("aria-busy", "true");
    btn.setAttribute("aria-disabled", "true");
    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (data.status) {
        return;
      }
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "pdp-accessory-slider",
          productVariantId: String(id),
          cartData: data,
        });
      }
      if (cart && cart.renderContents) {
        const isClosedCart = !document.body.classList.contains(
          "page-overlay-cart-on",
        );
        cart.renderContents(data, isClosedCart);
      } else if (!cart) {
        window.location = window.routes.cart_url;
      }
    } finally {
      btn.classList.remove("is-loading");
      btn.removeAttribute("aria-busy");
      btn.removeAttribute("aria-disabled");
    }
  }

  function bindAccessoryCard(card, root) {
    const behavior = root.dataset.behavior || "stage_with_main_atc";
    const variants = parseVariantsJson(card);
    const initialId =
      card.querySelector(".js-pdp-accessory-add")?.dataset.variantId;
    if (initialId) card.dataset.currentVariantId = initialId;

    card.querySelectorAll(".js-pdp-accessory-swatch").forEach((sw) => {
      sw.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const vid = sw.dataset.variantId;
        const v = findVariant(variants, vid);
        if (!v) return;
        card.querySelectorAll(".js-pdp-accessory-swatch").forEach((s) => {
          const sel = s === sw;
          s.classList.toggle("is-selected", sel);
          s.classList.toggle("active", sel);
          s.setAttribute("aria-pressed", sel ? "true" : "false");
        });
        applyVariantToCard(card, v, variants);
        const sectionEl = card.closest("[id^='shopify-section-']");
        const sectionId = sectionEl?.id?.replace("shopify-section-", "");
        if (sectionId && card.dataset.staged === "true") {
          dispatchStagingChanged(sectionId);
        }
      });
    });

    /*
      Dropdown picker — used when the card has multiple variants but no
      usable color-swatch UI (snippets/pdp-accessory-card.liquid drives
      that decision via `show_variant_select`). Routes the change
      through the same applyVariantToCard() that the swatch path uses,
      so image, price, variant label, and the ADD-button sold-out state
      all stay in sync. If the shopper selects a sold-out option, the
      button flips to "Sold out" + disabled and the existing
      addAccessoryImmediate / toggleStaged paths short-circuit on
      btn.disabled.
    */
    card.querySelectorAll(".js-pdp-acc-variant-select").forEach((select) => {
      select.addEventListener("change", (e) => {
        const vid = select.value;
        const v = findVariant(variants, vid);
        if (!v) return;
        applyVariantToCard(card, v, variants);
        const sectionEl = card.closest("[id^='shopify-section-']");
        const sectionId = sectionEl?.id?.replace("shopify-section-", "");
        if (sectionId && card.dataset.staged === "true") {
          dispatchStagingChanged(sectionId);
        }
      });
    });

    const addBtn = card.querySelector(".js-pdp-accessory-add");
    if (addBtn) {
      addBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (behavior === "add_on_click") {
          addAccessoryImmediate(card, root);
        } else {
          toggleStaged(card, root);
        }
      });
    }
  }

  function clearStagingInSection(sectionId) {
    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (!section) return;
    section.querySelectorAll('.js-pdp-accessory-card[data-staged="true"]').forEach((card) => {
      card.dataset.staged = "false";
      const btn = card.querySelector(".js-pdp-accessory-add");
      if (!btn) return;
      btn.classList.remove("is-staged");
      btn.setAttribute("aria-pressed", "false");
      const bag = btn.querySelector(".js-pdp-acc-btn-icon-bag");
      const check = btn.querySelector(".js-pdp-acc-btn-icon-check");
      const textStyle = isTextStyleAccessoryButton(btn);
      if (bag) bag.classList.toggle("hidden", textStyle);
      if (check) check.classList.add("hidden");
      // Show the label again (toggleStaged hides it when staged) and reset
      // the accessible name to the unstaged "Add <product>" form.
      const label = btn.querySelector(".js-pdp-acc-btn-label");
      if (label) label.classList.remove("hidden");
      const productTitle =
        card.querySelector(".wt-dot__title")?.textContent?.trim() || "";
      const defaultLabel = btn.dataset.labelDefault || "Add";
      btn.setAttribute(
        "aria-label",
        `${defaultLabel} ${productTitle}`.trim(),
      );
    });
    updateMainAtcButtonForSection(sectionId);
  }

  function onBeforeCartAdd(e) {
    const pf = e.detail?.productForm;
    const form = pf?.form;
    if (!form || form.getAttribute("data-type") !== "add-to-cart-form") return;

    const sectionId = getSectionIdFromProductForm(form);
    if (!sectionId) return;

    const staged = collectStagedLines(sectionId);
    if (!staged.length) return;

    e.preventDefault();

    pf.error = false;

    const mainId = Number(form.querySelector('[name="id"]')?.value);
    const qty = getMainQty(sectionId);
    if (!Number.isFinite(mainId)) return;

    const counts = new Map();
    counts.set(mainId, qty);
    staged.forEach((line) => {
      counts.set(line.id, (counts.get(line.id) || 0) + 1);
    });
    const items = [...counts.entries()].map(([id, quantity]) => ({
      id,
      quantity,
    }));

    const cart = document.querySelector("cart-drawer");
    const cartType = cart?.dataset?.cartType || "page";
    const body = {
      items,
      sections: cart?.getSectionsToRender?.().map((s) => s.id).join(",") || "",
      sections_url: window.location.pathname,
    };

    const loader = pf.querySelector(".loading-overlay__spinner");
    pf.submitButton.setAttribute("aria-disabled", "true");
    pf.submitButton.classList.add("loading");
    if (loader) loader.classList.remove("hidden");

    pf.handleErrorMessage();

    fetch(window.routes.cart_add_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: String(mainId),
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          pf.handleErrorMessage(response.description);
          pf.error = true;
          pf.dispatchEvent(
            new CustomEvent("cart-drawer:refresh", {
              detail: { response },
              bubbles: true,
              composed: true,
            }),
          );
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        clearStagingInSection(sectionId);

        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: String(mainId),
            cartData: response,
          });
        }
        pf.error = false;
        const quickAddModal = pf.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                pf.redirectAfterSubmit(response);
              });
            },
            { once: true },
          );
          if (cartType === "drawer") quickAddModal.hide(true);
        } else {
          const isClosedCart = !document.body.classList.contains(
            "page-overlay-cart-on",
          );
          pf.redirectAfterSubmit(response, isClosedCart);
        }
      })
      .catch((err) => {
        console.error(err);
        pf.error = true;
      })
      .finally(() => {
        if (cart && cart.classList.contains("is-empty")) {
          cart.classList.remove("is-empty");
        }
        pf.submitButton.removeAttribute("aria-disabled");
        if (pf.error) {
          pf.disableLoadingInButton();
          return;
        }
        setTimeout(() => {
          pf.disableLoadingInButton();
        }, 200);
      });
  }

  function initPdpAccessorySliders(root = document) {
    root.querySelectorAll("pdp-accessory-slider").forEach((slider) => {
      if (slider.dataset.pdpAccBound) return;
      slider.dataset.pdpAccBound = "1";
      slider.querySelectorAll(".js-pdp-accessory-card").forEach((card) => {
        bindAccessoryCard(card, slider);
      });
    });
  }

  document.addEventListener("product-form:before-cart-add", onBeforeCartAdd, true);

  document.addEventListener("DOMContentLoaded", () => {
    seedMainVariantFromDom();
    initPdpAccessorySliders();
    document.querySelectorAll("product-form[data-section-id]").forEach((pf) => {
      const sid = pf.dataset.sectionId;
      if (sid) updateMainAtcButtonForSection(sid);
    });

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
        const sid = payload?.data?.sectionId;
        const variant = payload?.data?.variant;
        if (!sid || !variant) return;
        window.__pdpAtcBySection = window.__pdpAtcBySection || {};
        window.__pdpAtcBySection[sid] = {
          variantId: variant.id,
          priceCents: variant.price,
          available: variant.available !== false,
        };
        updateMainAtcButtonForSection(sid);
      });
    }

    document.body.addEventListener("change", (ev) => {
      const t = ev.target;
      if (t?.matches?.('input[name="quantity"]')) {
        const form = t.closest("form");
        const sid = getSectionIdFromProductForm(form);
        if (sid) updateMainAtcButtonForSection(sid);
      }
    });
  });

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches?.("pdp-accessory-slider")) {
          initPdpAccessorySliders(n.parentElement || document);
        } else if (n.querySelector?.("pdp-accessory-slider")) {
          initPdpAccessorySliders(n);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  window.__pdpAccessoryStaging = {
    enabled: true,
    updateMainAtcButtonForSection,
    clearStagingInSection,
  };
})();

/**
 * Mobile Safari / Chrome: `fixed` + `100%` height track the *layout* viewport; when
 * the browser chrome shows or hides, a sliver of page can show under bottom-fixed
 * UI. Sync visual viewport height to `--wt-vvh` for CSS fallbacks.
 */
(function () {
  const vv = window.visualViewport;
  if (!vv) return;
  function syncVisualViewportSize() {
    const h = vv.height;
    if (!Number.isFinite(h) || h <= 0) return;
    document.documentElement.style.setProperty("--wt-vvh", `${Math.round(h)}px`);
  }
  vv.addEventListener("resize", syncVisualViewportSize, { passive: true });
  vv.addEventListener("scroll", syncVisualViewportSize, { passive: true });
  syncVisualViewportSize();
})();

/**
 * Cart drawer cross-sell: direct add-to-cart.
 *
 * Buttons in the cart drawer cross-sell module (rendered via cart-cross-sell.liquid
 * → shoppable-product-card.liquid with a customClass containing "cross-sell") use
 * `[data-cs-add]` instead of the `<quick-add>` wrapper. We intercept the click in
 * the capture phase, POST the variant directly to /cart/add.js, then refresh the
 * cart drawer + bubble using the section data returned in the same request.
 *
 * The Liquid in cart-cross-sell.liquid already excludes products already in the
 * cart (line_items_ids), so the just-added product naturally disappears from the
 * upsell on refresh. We animate the slide out first to soften the transition.
 *
 * Note: pointer / mouse / touch events on the button are stopped at the document
 * capture phase so Swiper's `slideToClickedSlide` behavior never triggers when
 * the user taps the ADD button on a partially-visible slide.
 */
(function () {
  const SELECTOR = "[data-cs-add]";
  const SLIDE_SELECTOR = "[data-swiper-slide]";
  const ERROR_SELECTOR = "[data-cs-error]";
  const REMOVE_ANIM_MS = 260;
  const REMOVE_CLASS = "wt-cart__cs-slide--removing";
  const LOADING_CLASS = "is-loading";
  const ERROR_AUTO_CLEAR_MS = 4500;

  function getCartDrawer() {
    return document.querySelector("cart-drawer");
  }

  function getSectionsParam() {
    const cd = getCartDrawer();
    if (cd && typeof cd.getSectionsToRender === "function") {
      return cd.getSectionsToRender().map((s) => s.id);
    }
    return ["cart-drawer", "cart-icon-bubble"];
  }

  function refreshCartDrawer(response) {
    const cd = getCartDrawer();
    if (!cd) return;
    if (response && response.sections && typeof cd.renderContents === "function") {
      cd.renderContents({ sections: response.sections }, false);
      return;
    }
    document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
  }

  function animateSlideOut(slide) {
    return new Promise((resolve) => {
      if (!slide) {
        resolve();
        return;
      }
      slide.classList.add(REMOVE_CLASS);
      setTimeout(resolve, REMOVE_ANIM_MS);
    });
  }

  function setLoading(btn, isLoading) {
    if (!btn) return;
    if (isLoading) {
      btn.classList.add(LOADING_CLASS);
      btn.setAttribute("aria-busy", "true");
      btn.setAttribute("aria-disabled", "true");
    } else {
      btn.classList.remove(LOADING_CLASS);
      btn.removeAttribute("aria-busy");
      btn.removeAttribute("aria-disabled");
    }
  }

  function findErrorEl(btn) {
    const card = btn.closest(".shoppable-product-card");
    if (!card) return null;
    return card.querySelector(ERROR_SELECTOR);
  }

  function showError(btn, message) {
    const el = findErrorEl(btn);
    if (!el) return;
    el.textContent = message || "Sorry, we couldn’t add this item. Please try again.";
    el.hidden = false;
    if (el._csClearTimer) clearTimeout(el._csClearTimer);
    el._csClearTimer = setTimeout(() => {
      el.hidden = true;
      el.textContent = "";
    }, ERROR_AUTO_CLEAR_MS);
  }

  function clearError(btn) {
    const el = findErrorEl(btn);
    if (!el) return;
    if (el._csClearTimer) clearTimeout(el._csClearTimer);
    el.hidden = true;
    el.textContent = "";
  }

  // Stop pointer/mouse/touch events on the ADD button at the document capture
  // phase so Swiper's slideToClickedSlide handler never sees them. Without this,
  // tapping ADD on a partially-visible slide first animates the slide into view
  // and only then fires the add — feels janky.
  function stopPointerOnCsAdd(e) {
    const target = e.target instanceof Element ? e.target : null;
    if (target && target.closest(SELECTOR)) {
      e.stopPropagation();
    }
  }
  ["pointerdown", "mousedown", "touchstart"].forEach((evt) => {
    document.addEventListener(evt, stopPointerOnCsAdd, true);
  });

  function handleCsAddClick(e) {
    const target = e.target instanceof Element ? e.target : null;
    if (!target) return;
    const btn = target.closest(SELECTOR);
    if (!btn) return;
    if (btn.disabled || btn.getAttribute("aria-busy") === "true") {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    const variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    const slide = btn.closest(SLIDE_SELECTOR);
    clearError(btn);
    setLoading(btn, true);

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", "1");
    formData.append("sections", getSectionsParam().join(","));
    formData.append("sections_url", window.location.pathname);

    const config =
      typeof fetchConfig === "function" ? fetchConfig("javascript") : { method: "POST", headers: {} };
    if (config.headers) {
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
    }
    config.body = formData;

    const addUrl =
      (window.routes && window.routes.cart_add_url) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root + "cart/add.js") ||
      "/cart/add.js";

    fetch(addUrl, config)
      .then((r) => r.json())
      .then((response) => {
        if (response && response.status) {
          setLoading(btn, false);
          showError(btn, response.description || response.message);
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "cart-cross-sell",
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          return;
        }

        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-cross-sell",
            productVariantId: variantId,
            cartData: response,
          });
        }

        // Fade the just-added card out, then re-render the drawer so the
        // refreshed cross-sell (which excludes products already in cart) takes
        // its place underneath.
        animateSlideOut(slide).then(() => {
          refreshCartDrawer(response);
        });
      })
      .catch((err) => {
        console.error("[cart-cross-sell] add failed:", err);
        setLoading(btn, false);
        showError(btn);
      });
  }

  document.addEventListener("click", handleCsAddClick, true);
})();

/**
 * Video autoplay fallback.
 *
 * On mobile devices with iOS Low Power Mode, "Auto-Play Video Previews" disabled
 * in Accessibility, Android Data Saver, or similar privacy/battery settings, the
 * browser refuses to autoplay <video> elements regardless of muted/playsinline.
 *
 * This module:
 *   1. Wraps HTMLMediaElement.prototype.play() once. When a play() promise
 *      rejects with NotAllowedError (the autoplay-blocked signal), we tag the
 *      enclosing container with `.wt-video-needs-tap` so CSS reveals a tap-to-
 *      play overlay.
 *   2. Polls videos that still have the Shopify-generated `autoplay` attribute
 *      and are paused after the page has loaded — the browser tried, failed,
 *      and never threw at us because the JS never called play() directly.
 *   3. On the first successful user-initiated play, retries every other tagged
 *      video. Mobile browsers often relax autoplay restrictions for the rest
 *      of the session once the user has interacted with media.
 *
 * No section-specific JS is patched; the wrap catches every `.play()` site.
 */
(function () {
  if (HTMLMediaElement.prototype.__wtAutoplayFallbackWrapped) return;
  HTMLMediaElement.prototype.__wtAutoplayFallbackWrapped = true;

  const FAILED_CLASS = "wt-video-needs-tap";
  const POSTER_COVER_CLASS = "wt-video-poster-cover";
  const HAS_COVER_CLASS = "wt-video-has-cover";
  const failedVideos = new WeakSet();
  const wiredContainers = new WeakSet();
  const posterCovers = new WeakMap();

  function getOverlayHost(video) {
    return (
      video.closest(".wt-video-hosted") ||
      video.closest(".wt-video__movie") ||
      video.closest("video-controls") ||
      video.closest(".swiper-slide") ||
      video.closest(".shoppable-video__container") ||
      video.closest(".hero--video-background") ||
      video.closest("low-power-video") ||
      video.parentElement
    );
  }

  function ensurePlaybackAttrs(video) {
    try {
      video.muted = true;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
    } catch (e) {
      /* no-op */
    }
  }

  /*
    iOS Safari low-power / autoplay-blocked native play overlay.

    When autoplay is blocked OR there's any gap between when iOS first
    paints the video element and when it actually starts playing
    (network buffering, slow device, "Auto-Play Video Previews" off,
    Low Power Mode), iOS Safari paints its own play button into the
    <video> element's rendering. It's NOT a shadow-DOM child we can
    reliably hide via CSS — the standard `::-webkit-media-controls-*`
    pseudo-element hides work for most cases, but iOS ignores them in
    enough scenarios that we need a real DOM cover.

    The fix: drop a real <img class="wt-video-poster-cover"> with the
    video's poster URL into the same host that the video lives in.
    That img is a normal DOM element, so it stacks above the video's
    paint (including any native iOS button) and visually masks it.

    Timing strategy:
      - Inject the cover PREEMPTIVELY at script time for every autoplay
        video. This kills the brief native-button flash that appears
        between page parse and when the video actually starts playing,
        which one of our beta users was seeing outside low-power mode.
      - Remove it on the `playing` event (autoplay or user-initiated
        play succeeded — real frames are visible now, no need for the
        poster cover).
      - If autoplay never starts (the existing poll catches paused
        autoplay videos or wrapped play() catches NotAllowedError),
        the host gets `.wt-video-needs-tap` and our corner tap-to-play
        badge renders ABOVE the cover.

    We reuse the poster URL the <video> already references, so the
    browser cache services the img request — no extra round trip.
  */
  function ensurePosterCover(video, host) {
    if (!video || !host) return;
    if (posterCovers.has(video)) return;
    // If the video is already playing real frames (e.g., we got here
    // after autoplay already kicked in on a fast device), there's
    // nothing for us to hide and a cover would just stay stuck.
    if (!video.paused && video.currentTime > 0) return;
    const posterUrl = video.getAttribute("poster") || video.poster || "";
    if (!posterUrl) return;

    const img = document.createElement("img");
    img.className = POSTER_COVER_CLASS;
    img.src = posterUrl;
    img.alt = "";
    img.setAttribute("aria-hidden", "true");
    img.decoding = "async";
    img.loading = "eager";

    host.appendChild(img);
    host.classList.add(HAS_COVER_CLASS);
    posterCovers.set(video, img);

    // Auto-remove the cover the moment the video actually starts playing.
    // `playing` is the canonical event; `timeupdate` is a belt-and-suspenders
    // fallback in case `playing` never fires for some browser-quirk reason
    // (we've seen edge cases on Android WebView). Whichever fires first
    // strips both listeners.
    const onActuallyPlaying = () => {
      video.removeEventListener("playing", onActuallyPlaying);
      video.removeEventListener("timeupdate", onActuallyPlaying);
      removePosterCover(video);
    };
    video.addEventListener("playing", onActuallyPlaying);
    video.addEventListener("timeupdate", onActuallyPlaying);
  }

  function removePosterCover(video) {
    const img = posterCovers.get(video);
    if (img) {
      const host = img.parentNode;
      if (host) {
        host.removeChild(img);
        if (!host.querySelector("." + POSTER_COVER_CLASS)) {
          host.classList.remove(HAS_COVER_CLASS);
        }
      }
    }
    posterCovers.delete(video);
  }

  /*
    Install preemptive covers for any autoplay <video> on the page.
    Safe to call repeatedly — ensurePosterCover bails out if a cover
    already exists for the given video.

    Includes videos that low-power-video.js has temporarily stashed
    `autoplay` into `data-lpv-autoplay` (lazy-loaded videos waiting on
    IntersectionObserver). They'll attempt autoplay when they resume,
    and we want the cover ready then.
  */
  function installCoversForAutoplayVideos(root) {
    const scope = root || document;
    scope.querySelectorAll("video").forEach((v) => {
      if (!(v instanceof HTMLVideoElement)) return;
      if (
        !v.hasAttribute("autoplay") &&
        v.dataset.lpvAutoplay !== "true"
      )
        return;
      const host = getOverlayHost(v);
      if (host) ensurePosterCover(v, host);
    });
  }

  function clearFailed(video) {
    failedVideos.delete(video);
    const host = getOverlayHost(video);
    if (host) host.classList.remove(FAILED_CLASS);
    removePosterCover(video);
  }

  function retryAllFailedVideos() {
    document.querySelectorAll("video").forEach((v) => {
      if (!failedVideos.has(v)) return;
      ensurePlaybackAttrs(v);
      const p = v.play();
      if (p && p.then) p.catch(() => {});
    });
  }

  function markFailed(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    const host = getOverlayHost(video);
    if (!host) return;
    failedVideos.add(video);
    host.classList.add(FAILED_CLASS);
    ensurePosterCover(video, host);
    if (wiredContainers.has(host)) return;
    wiredContainers.add(host);

    const onGesture = (e) => {
      if (e && e.cancelable === false) {
        /* passive */
      }
      ensurePlaybackAttrs(video);
      let p;
      try {
        p = video.play();
      } catch (err) {
        return;
      }
      if (p && p.then) {
        p.then(() => {
          clearFailed(video);
          window.__wtAutoplayUnlocked = true;
          retryAllFailedVideos();
        }).catch(() => {
          /* still blocked; overlay stays */
        });
      } else {
        clearFailed(video);
      }
    };

    host.addEventListener("click", onGesture, { passive: true });
    host.addEventListener("touchend", onGesture, { passive: true });
  }

  const origPlay = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function wtWrappedPlay() {
    let p;
    try {
      p = origPlay.apply(this, arguments);
    } catch (e) {
      p = Promise.reject(e);
    }
    if (p && typeof p.then === "function") {
      const self = this;
      p.then(
        () => {
          if (self instanceof HTMLVideoElement) clearFailed(self);
        },
        (err) => {
          if (err && err.name === "NotAllowedError" && self instanceof HTMLVideoElement) {
            markFailed(self);
          }
        },
      );
    }
    return p;
  };

  function pollAutoplayAttributeVideos() {
    document.querySelectorAll("video[autoplay]").forEach((v) => {
      if (failedVideos.has(v)) return;
      if (v.paused && v.readyState >= 2) {
        markFailed(v);
      }
    });
  }

  function schedulePolls() {
    setTimeout(pollAutoplayAttributeVideos, 700);
    setTimeout(pollAutoplayAttributeVideos, 2500);
    setTimeout(pollAutoplayAttributeVideos, 6000);
  }

  if (document.readyState === "complete") {
    schedulePolls();
  } else {
    window.addEventListener("load", schedulePolls, { once: true });
  }

  // Retry tagged videos on any user gesture; some mobile browsers relax autoplay
  // restrictions for the rest of the session once the user has interacted.
  // (WeakSet can't be enumerated so we just unconditionally walk every <video>
  // and skip ones that aren't tagged.)
  ["click", "touchend", "keydown"].forEach((evt) => {
    document.addEventListener(evt, retryAllFailedVideos, { passive: true, capture: true });
  });

  // ---- Preemptive poster covers ---------------------------------------------
  //
  // Install covers ASAP — first on whatever's already in the DOM when this
  // deferred script runs, then again at DOMContentLoaded as a safety net for
  // anything mid-parse. The defer attribute guarantees DOM is complete by the
  // time we run, but we keep the listener as a no-op fallback.
  installCoversForAutoplayVideos(document);
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => installCoversForAutoplayVideos(document),
      { once: true },
    );
  }

  // Watch for autoplay videos added after initial parse (Shopify section
  // re-renders in the theme editor, AJAX cart re-renders that include video
  // tiles, low-power-video resume swapping `autoplay` back onto the element,
  // etc.). The observer covers added subtrees and attribute mutations on
  // existing <video> nodes.
  if ("MutationObserver" in window) {
    const mo = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (node instanceof HTMLVideoElement) {
              if (
                node.hasAttribute("autoplay") ||
                node.dataset.lpvAutoplay === "true"
              ) {
                const host = getOverlayHost(node);
                if (host) ensurePosterCover(node, host);
              }
            } else if (node instanceof Element) {
              installCoversForAutoplayVideos(node);
            }
          });
        } else if (
          mutation.type === "attributes" &&
          mutation.target instanceof HTMLVideoElement &&
          (mutation.attributeName === "autoplay" ||
            mutation.attributeName === "data-lpv-autoplay")
        ) {
          const v = mutation.target;
          if (
            v.hasAttribute("autoplay") ||
            v.dataset.lpvAutoplay === "true"
          ) {
            const host = getOverlayHost(v);
            if (host) ensurePosterCover(v, host);
          }
        }
      }
    });
    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["autoplay", "data-lpv-autoplay"],
    });
  }
})();

/**
 * Native rating block -> Yotpo reviews scroll bridge.
 *
 * The Liquid snippet (snippets/rating.liquid) renders the stars + counter
 * inside an <a data-scroll-to-reviews href="#yotpo-reviews"> when the
 * "Link stars to reviews" setting is on. The literal `#yotpo-reviews`
 * anchor doesn't exist in the DOM (Yotpo widgets emit a dynamically-id'd
 * `shopify-section-…` wrapper instead), so we intercept the click and
 * locate the widget via class selectors that work across Yotpo v2/v3.
 */
(function () {
  function findYotpoReviewsTarget(link) {
    const href = link.getAttribute("href") || "";
    if (href.startsWith("#") && href.length > 1) {
      const el = document.getElementById(href.slice(1));
      if (el) return el;
    }
    return (
      document.querySelector(
        '.yotpo-widget-instance[data-yotpo-element-id*="reviews-main-widget"]',
      ) ||
      document.querySelector('[data-yotpo-element-id="reviews-main-widget"]') ||
      document.querySelector(".yotpo-main-widget") ||
      document.querySelector(".yotpo-reviews-main-widget") ||
      document.querySelector('[class*="yotpo"][data-product-id]') ||
      null
    );
  }

  document.addEventListener("click", (event) => {
    const link = event.target.closest("[data-scroll-to-reviews]");
    if (!link) return;

    const target = findYotpoReviewsTarget(link);
    if (!target) return;

    event.preventDefault();

    const header = document.querySelector(".wt-header");
    const headerOffset = (header && header.offsetHeight) || 0;
    const top =
      target.getBoundingClientRect().top + window.scrollY - headerOffset - 16;

    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  });
})();

/**
 * PDP short description -> full description scroll bridge.
 */
(function () {
  function findDescriptionTarget(link) {
    const raw = (link.getAttribute("data-scroll-target") || "pdp-full-description").trim();
    if (!raw) return null;
    const id = raw.startsWith("#") ? raw.slice(1) : raw;
    return document.getElementById(id);
  }

  document.addEventListener("click", (event) => {
    const link = event.target.closest("[data-scroll-to-pdp-description]");
    if (!link) return;

    const target = findDescriptionTarget(link);
    if (!target) return;

    event.preventDefault();

    const header = document.querySelector(".wt-header");
    const headerOffset = (header && header.offsetHeight) || 0;
    const top =
      target.getBoundingClientRect().top + window.scrollY - headerOffset - 16;

    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  });
})();

/**
 * Hydrate Yotpo Star Rating placeholders on collection cards (and similar
 * surfaces) after the app embed script loads. PDP uses the app block; cards
 * use snippets/yotpo-star-rating.liquid.
 */
(function initYotpoCollectionStarRatings() {
  function refreshPendingYotpoWidgets() {
    const pending = document.querySelectorAll(
      ".wt-yotpo-star-rating:not([data-yotpo-element-loaded])",
    );
    if (!pending.length) return;

    if (
      window.yotpoWidgetsContainer &&
      typeof window.yotpoWidgetsContainer.initWidgets === "function"
    ) {
      window.yotpoWidgetsContainer.initWidgets();
    }
  }

  function scheduleRefresh() {
    refreshPendingYotpoWidgets();
    window.setTimeout(refreshPendingYotpoWidgets, 500);
    window.setTimeout(refreshPendingYotpoWidgets, 1500);
  }

  if (document.readyState === "complete") {
    scheduleRefresh();
  } else {
    window.addEventListener("load", scheduleRefresh, { once: true });
  }

  document.addEventListener("shopify:section:load", scheduleRefresh);
})();
